import { render, staticRenderFns } from "./CameraPageIntroductionPcCardImages.vue?vue&type=template&id=143115aa&scoped=true&"
import script from "./CameraPageIntroductionPcCardImages.vue?vue&type=script&lang=ts&"
export * from "./CameraPageIntroductionPcCardImages.vue?vue&type=script&lang=ts&"
import style0 from "./CameraPageIntroductionPcCardImages.vue?vue&type=style&index=0&id=143115aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143115aa",
  null
  
)

export default component.exports